export type IError = {
	statusCode: number;
	error: {
		code: string;
		message: string;
	};
};

export class ApiError extends Error {
	error: IError['error'];
	statusCode: number;
	code?: string;

	constructor(error: IError) {
		super(`[${error.error.code}]: ${error.error.message}`);
		this.error = error.error;
		this.statusCode = error.statusCode;
		this.code = error.error.code;
		this.name = 'ApiError';
	}

	toString() {
		return `[${this.code}]: ${this.error.message}\n${this.stack}`;
	}
}
